/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint no-unused-vars: 0, no-var: 0 */
/* globals _ */

_.namespace(`mp.marketing.trends`, function(ns) {
  'use strict';

  function TrendsApi() { }

  TrendsApi.prototype.query = function(params, callback) {
    params[`project_id`] = 161590;
    $.getJSON(`/api/2.0/trends/`, params).done(callback);
  };

  return {
    TrendsApi,
  };
});

}.call(window));